import * as Parts from './Tabs.parts'
export { Tabs } from './Tabs'
export { TabsList } from './TabsList'
export { TabsTrigger } from './TabsTrigger'
export const TabsContent = Parts.Content
